/* ══════════════════════════════════════════════════════════════
   Variant Detection & Configuration
   Supports: india (markets), india-economy, india-tech
   ══════════════════════════════════════════════════════════════ */

export type Variant = 'india' | 'india-economy' | 'india-tech';

export interface VariantConfig {
    id: Variant;
    name: string;
    shortName: string;
    icon: string;
    description: string;
    primaryColor: string;
    focusAreas: string[];
}

export const VARIANTS: Record<Variant, VariantConfig> = {
    india: {
        id: 'india',
        name: 'India Markets',
        shortName: 'MARKETS',
        icon: '📈',
        description: 'Stock indices, FII/DII flows, options, IPOs, earnings',
        primaryColor: '#FF6B35',
        focusAreas: ['Nifty 50', 'Bank Nifty', 'FII/DII', 'Options', 'IPO', 'Earnings', 'MCX'],
    },
    'india-economy': {
        id: 'india-economy',
        name: 'India Economy',
        shortName: 'ECONOMY',
        icon: '🏛',
        description: 'GDP, RBI policy, inflation, infrastructure, government policy',
        primaryColor: '#3B82F6',
        focusAreas: ['GDP', 'RBI', 'Inflation', 'Infrastructure', 'GST', 'Trade Balance', 'Forex'],
    },
    'india-tech': {
        id: 'india-tech',
        name: 'India Tech',
        shortName: 'TECH',
        icon: '💻',
        description: 'Startups, IT sector, funding, digital India, tech policy',
        primaryColor: '#8B5CF6',
        focusAreas: ['Startups', 'IT Sector', 'VC Funding', 'Digital India', 'Unicorns', 'SaaS'],
    },
};

/** Detect current variant from environment */
export function getCurrentVariant(): Variant {
    const env = import.meta.env.VITE_VARIANT;
    if (env && env in VARIANTS) {
        return env as Variant;
    }
    return 'india';
}

/** Get current variant config */
export function getVariantConfig(): VariantConfig {
    return VARIANTS[getCurrentVariant()];
}
